/**
 * SCM Page Renderer — thin wrapper over the generic WmsPageRenderer.
 * The WmsPageRenderer is fully data-driven; the "WMS" prefix is historical.
 */
import WmsPageRenderer from '@/components/wms/WmsPageRenderer';
import type { WmsPageDef } from '@/components/wms/wms-page-dsl';

export type ScmPageDef = WmsPageDef;

export default function ScmPageRenderer({ pageDef }: { pageDef: ScmPageDef }) {
  return <WmsPageRenderer pageDef={pageDef} />;
}
